import React from 'react';
import { FaCheckCircle, FaSpinner, FaClipboardList, FaTools } from 'react-icons/fa';
import Marquee from 'react-fast-marquee';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

import logo1 from '../../assets/images/CEDCoatings-Logo.png';
import logo2 from '../../assets/images/labh.png';
import logo3 from '../../assets/images/HHG_FinalLogo.png';
import logo4 from '../../assets/images/INFOTEK-Logo.png';
import logo5 from '../../assets/images/LybDryve-Logo-.png';

const stats = [
  {
    icon: <FaCheckCircle size={30} />,
    label: 'Completed Projects',
    count: 120,
    color: 'text-green-600',
  },
  {
    icon: <FaSpinner size={30} />,
    label: 'Ongoing Projects',
    count: 8,
    color: 'text-blue-500',
  },
  {
    icon: <FaClipboardList size={30} />,
    label: 'Projects In-Hand',
    count: 15,
    color: 'text-yellow-500',
  },
  {
    icon: <FaTools size={30} />,
    label: 'Under Development',
    count: 5,
    color: 'text-purple-600',
  },
];

const logos = [logo1, logo2, logo3, logo4, logo5];

const Customer = () => {
  const { ref, inView } = useInView({ triggerOnce: true });

  return (
    <div className="w-full bg-gray-50 py-12 px-4 md:px-20">
      
      {/* Section Title and Slogan */}
      <div className="text-center mb-10">
        <h2 className="text-3xl font-bold text-gray-800 mb-2" style={{color:'deepskyblue'}}>Trusted by Industry Leaders</h2>
        <p className="text-gray-600 text-lg">
          Our excellence echoes through our partnerships – powering success, one project at a time.
        </p>
      </div>

      {/* Row 1 - Seamless Customer Logos */}
      <div className="overflow-hidden mb-12">
        <Marquee speed={50} pauseOnHover gradient={false}>
          {logos.concat(logos).map((logo, index) => (
            <img
              key={index}
              src={logo}
              alt={`Client Logo ${index + 1}`}
              className="h-16 mx-8 grayscale hover:grayscale-0 transition duration-300"
              loading="lazy"
            />
          ))}
        </Marquee>
      </div>

      {/* Row 2 - Count-Up Stats */}
      <div ref={ref} className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
        {stats.map((item, index) => (
          <div
            key={index}
            className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition duration-300"
          >
            <div className={`flex justify-center items-center mb-2 text-3xl ${item.color}`}>
              {item.icon}
            </div>
            <h3 className="text-3xl font-bold text-gray-800 mb-1">
              {inView ? <CountUp end={item.count} duration={2} /> : '0'}+
            </h3>
            <p className="text-sm font-medium text-gray-600">{item.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Customer;
